import type { FunctionalComponent } from "preact";
import Headline from "../Headline";

export interface Props {
    devices: MediaDeviceInfo[];
    current: string;
    headline: string;
    class?: string;
    onSelected?: (deviceID: string) => void;
}

const truncate = (str: string, n: number) => {
    return str.length > n ? `${str.slice(0, n - 1)}...` : str;
};

const Device: FunctionalComponent<Props> = (props) => {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const onChange = (e: any) => {
        if (e.target?.value !== null && props.onSelected) {
            props.onSelected(e.target.value);
        }
    };

    return (
        <div class={`w-48 ${props.class}`}>
            <Headline text={props.headline} />

            {props.devices.length > 0 && (
                <select
                    onChange={onChange}
                    class="mt-1 block w-full rounded-md border-0 py-1 pr-10 pl-3 text-gray-900 text-xs ring-1 ring-gray-300 ring-inset focus:ring-2 focus:ring-[#00c3e3]"
                >
                    {props.devices.map((device) => (
                        <option
                            selected={props.current === device.deviceId}
                            value={device.deviceId}
                            key={device.deviceId}
                        >
                            {truncate(device.label, 26)}
                        </option>
                    ))}
                </select>
            )}

            {props.devices.length === 0 && (
                <div class="mt-1 text-center font-normal text-white text-xs">No devices found.</div>
            )}
        </div>
    );
};

export default Device;
